<template>
    <div class="drawElectronicFence">
        <div class="map-con">
            <!-- 操作按钮 -->
            <div class="handle-types">
                <el-button type="primary" round plain size="small" @click="handleAddMark" :class="{'active': handleType===1}">
                    位置标点
                </el-button>
                <template v-if="!onlyPoint">
                    <el-button type="primary" round plain size="small" @click="handleDrawFence" :class="{'active': handleType===2}">
                        绘制电子围栏
                    </el-button>
                    <el-button type="danger" round plain size="small" @click="handleClearFence">
                        清除电子围栏
                    </el-button>
                </template>
            </div>
            <!-- 地图 -->
            <baidu-map class="baidu-map" :zoom="zoom" :center="mapCenter" @ready="handleReady" @click="clickMap">
                <bm-local-search class="search-panel" :keyword="searchVal" :auto-viewport="true" :panel="showPanel" @infohtmlset="onSearchResult"></bm-local-search>
                <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
                <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" panel show-address-bar></bm-geolocation>
                <!-- 点标记 -->
                <bm-marker :position="location.position" @click="window.visible=true"></bm-marker>
                <!-- 已经关联项目点标记 -->
                <bm-marker
                    v-for="(item, i) in associatedProject"
                    :position="item.position"
                    :icon="item.icon"
                    :key="`associatedProject${i}`"
                    :offset="item.offset"
                    :label="item.label"
                >
                    <bm-label :content="`${item.project_name}`" :offset="item.offset"></bm-label>
                </bm-marker>
                <!-- 未关联项目点标记 -->
                <bm-marker
                    v-for="(item, i) in unconnectedItems"
                    :position="item.position"
                    :icon="item.icon"
                    :key="`unconnectedItems${i}`"
                    :label="item.label"
                    @click="associatedProjects(item)"
                >
                    <bm-label :content="`${item.project_name}`" :offset="item.offset"></bm-label>
                </bm-marker>
                <!-- 信息窗体 -->
                <bm-info-window :position="window.position" :show="window.visible" :offset="{ width: 10, height: -30}">
                    {{ window.content }}
                </bm-info-window>
                <!--电子围栏（统一显示所有围栏）-->
                <template v-if="fencePolygons && fencePolygons.length > 0">
                    <bm-polygon
                        v-for="(fence, index) in fencePolygons"
                        :key="`fence-${index}`"
                        :path="fence.points"
                        stroke-color="#80d8ff"
                        fill-color="#00b0ff"
                        :stroke-opacity="fence.isActive ? 0.6 : 0.3"
                        :stroke-weight="fence.isActive ? 3 : 2"
                        :editing="false"
                    ></bm-polygon>
                </template>
            </baidu-map>
            <!-- 搜索 -->
            <div class="search-con">
                <input type="text" autocomplete="off" placeholder="请输入关键字" v-model="keyword">
                <span class="search-btn" @click="search">搜索</span>
            </div>
            <div class="handle-btn">
                <el-button type="primary" size="medium" @click="handleSave">
                    确定
                </el-button>
                <el-button size="medium" @click="handleClose">
                    取消
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import BaiduMap from 'vue-baidu-map-v3'
Vue.use(BaiduMap, {
    ak: '7FR14186sYk3MqjP9ggWxuHx1AQkRzZX'
})
import BMapLib from '@/assets/map/BMapLib.js';
export default {
    components: {},
    props: {
        extr: {
            type: Object,
        },
    },
    data() {
        return {
            zoom: 14,
            mapCenter: {lng: 116.397428, lat: 39.90923},
            mouseTool: {},
            // 定位信息
            location: {
                position: {},
                address: '',
            },
            // 统一的围栏数组（包含所有围栏数据）
            fencePolygons: [],
            // 当前绘制围栏的点索引
            drawIndex: 0,
            // 是否正在绘制围栏
            isDrawing: false,
            // 绘制电子围栏 开关
            drawTurn: false,
            window: {
                position: {lng: 0.0, lat: 0.0},
                visible: false,
            },
            mapObj: {}, // 地图对象
            BMap: {},
            handleType: 1, // 1 打点 2 绘制围栏
            echoPolygon: null, // 回显围栏图层
            onlyPoint: false,
            keyword: '',
            searchVal: '',
            showPanel: false,
            // 已关联项目点标记
            associatedProject:[],
            // 未关联项目点标记
            unconnectedItems:[],
            // 已选关联项目
            selectAssociatedProjects: '',


        };
    },
    methods: {
        // 地图
        handleReady({ BMap, map }) {
            this.BMap = BMap;
            this.mapObj = map;
            // 开启鼠标滚动缩放地图
            map.enableScrollWheelZoom(true);
            this.init();
        },
        async init() {
            this.onlyPoint = this.extr.onlyPoint || false;
            // 回显电子围栏
        if (this.extr.fence_point) {
            const polygons = this.parseFenceData(this.extr.fence_point);
            this.fencePolygons = polygons;
        }
            if (!(this.extr.position[0] && this.extr.position[1])) {
                await this.getDefaultPostion();
            }
            const point =  new this.BMap.Point(this.extr.position[0], this.extr.position[1]);
            this.clickMap({point});
            this.mapCenter = point;
            if(this.extr.projectnumber && this.extr.projectnumber !== '' && this.extr.type === 1){
                // 获取标记周边已关联项目
                this.getAssociatedProject();
            }
        },
        // 解析围栏数据（支持多个围栏，使用@分隔）
        parseFenceData(fence_point) {
            if (!fence_point || typeof fence_point !== 'string') {
                return [];
            }

            const fences = fence_point.split('@');
            if (fences.length === 0 || (fences.length === 1 && fences[0].trim() === '')) {
                return [];
            }

            const result = [];
            fences.forEach((fenceStr, index) => {
                if (!fenceStr || typeof fenceStr !== 'string') {
                    return;
                }

                const trimmedFence = fenceStr.trim();
                if (trimmedFence === '') {
                    return;
                }

                const arr = trimmedFence.split('|');
                if (arr.length < 3) {
                    return;
                }

                const points = arr.map(item => {
                    const lngLat = item.split(',');
                    if (lngLat.length !== 2) return null;
                    const lng = parseFloat(lngLat[0]);
                    const lat = parseFloat(lngLat[1]);
                    if (isNaN(lng) || isNaN(lat)) return null;
                    return new this.BMap.Point(lng, lat);
                }).filter(point => point !== null);

                if (points.length >= 3) {
                    result.push({
                        points: points,
                        path: trimmedFence,
                        timestamp: Date.now() + index,
                        isActive: false
                    });
                }
            });

            return result;
        },

        // 确定
        handleSave() {
            if(this.selectAssociatedProjects === ''){
                this.selectAssociatedProjects = this.extr.projectnumber;
            }

            // 选择地址不能为空
            if(!this.location.address) {
                this.$message.warning('请选择坐标点！');
                return;
            }
            // 使用统一的围栏数据
            const allFences = [...this.fencePolygons];

            // 检查是否有围栏数据（电子围栏现在为非必填）
            const hasValidFences = allFences.length > 0 && allFences.some(fence => fence.points && fence.points.length >= 3);

            // 如果有围栏，检查位置是否在任何围栏内
            if (hasValidFences) {
                const point = new BMap.Point(this.location.position.lng, this.location.position.lat);
                let isInsideAnyFence = false;

                for (let fence of allFences) {
                    if (fence.points && fence.points.length >= 3) {
                        const polygons = new BMap.Polygon(fence.points);
                        const b = BMapLib.GeoUtils.isPointInPolygon(point, polygons);
                        if (b) {
                            isInsideAnyFence = true;
                            break;
                        }
                    }
                }

                if (!isInsideAnyFence) {
                    this.$message.warning('位置标点不在任何电子围栏范围内，请重新标注或重新绘制围栏！');
                    return;
                }
            }

            const pos = [this.location.position.lng,this.location.position.lat];
            // 传递合并后的所有围栏数据
            this.extr.sureCallback(allFences, pos, this.location.address, this.selectAssociatedProjects);
            window.hideToast();
        },
        // 取消
        handleClose() {
            window.hideToast();
        },

        // 清除电子围栏
        handleClearFence() {
            if(this.fencePolygons.length === 0){
                this.$message.warning('没有电子围栏可以清除！');
                return;
            }
            this.$confirm('确定要清除所有电子围栏吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fencePolygons = [];
                this.isDrawing = false;
                this.drawTurn = false;
                this.drawIndex = 0;
                this.mapObj.removeEventListener('click', this.drawFenceClick);
                this.mapObj.removeEventListener('mousemove', this.drawFenceMove);
                this.mapObj.removeEventListener('rightclick', this.drawFenceRightclick);
                this.mapObj.addEventListener('click', this.clickMap);
                this.$message.success('电子围栏已清除');
            });
        },

        // 绘制
        draw() {
            const polygon = new AMap.Polygon({
              fillColor:'#00b0ff',
              strokeColor:'#80d8ff',
              path: [],
              //同Polygon的Option设置
            });
            return polygon;
        },
        search () {
            this.searchVal = this.keyword;
            this.showPanel = true;
        },
        // 搜索打点
        onSearchResult(result) {
            this.showPanel = false;
            this.location = {
                position: result.point,
                address: result.address,
            }
            this.window.position = result.point;
            this.window.content = result.address;
            this.window.visible = true;
            // 获取标记周边项目
            this.getUnconnectedItems(result.point)
            this.mapCenter = result.point;
        },
        // 绘制电子围栏
        drawFence() {
            // 清除之前所有围栏的活动状态
            this.fencePolygons.forEach(fence => fence.isActive = false);
            this.drawTurn = true;
            this.isDrawing = true;
            this.drawIndex = 0;
            this.drawFenceClick = this.drawFenceClick.bind(this);
            this.drawFenceMove = this.drawFenceMove.bind(this);
            this.drawFenceRightclick = this.drawFenceRightclick.bind(this);
        },
        // 点击地图定位
        clickMap({point}) {
            if (this.handleType === 1) {
                let geocoder = new this.BMap.Geocoder();
                geocoder.getLocation(point, (result) => {
                    if (result) {
                        this.location = {
                            position: result.point,
                            address: result.address,
                        }
                        this.window.position = result.point;
                        this.window.content = result.address;
                        this.window.visible = true;
                        // 获取标记周边项目
                        this.getUnconnectedItems(result.point)
                    }
                });
            }
        },

        // 此时操作打点
        handleAddMark() {
            this.handleType = 1;
            this.isDrawing = false;
            this.drawTurn = false;
            this.drawIndex = 0;

            // 清除当前活动的围栏状态
            this.fencePolygons.forEach(fence => fence.isActive = false);

            // 移除绘制围栏的事件监听器
            this.mapObj.removeEventListener('click', this.drawFenceClick);
            this.mapObj.removeEventListener('mousemove', this.drawFenceMove);
            this.mapObj.removeEventListener('rightclick', this.drawFenceRightclick);

            // 添加点击地图定位的事件监听器
            this.mapObj.addEventListener('click', this.clickMap);
        },
        // 此时操作绘制围栏
        handleDrawFence() {
            this.handleType = 2;
            this.window.visible = false;
            this.drawTurn = true;
            this.isDrawing = true;
            this.drawIndex = 0;
            this.mapObj.removeEventListener('click', this.clickMap);
            this.mapObj.addEventListener('click', this.drawFenceClick);
            this.mapObj.addEventListener('mousemove', this.drawFenceMove);
            this.mapObj.addEventListener('rightclick', this.drawFenceRightclick);
            this.drawFence();
        },
        drawFenceClick({point}) {
            if(!this.drawTurn || !this.isDrawing) {
                return;
            }

            // 获取当前活动的围栏，如果没有则创建新的
            let activeFence = this.fencePolygons.find(fence => fence.isActive);
            if (!activeFence) {
                activeFence = {
                    points: [],
                    path: '',
                    timestamp: Date.now(),
                    isActive: true
                };
                this.fencePolygons.push(activeFence);
            }

            if(this.drawIndex === activeFence.points.length - 1) {
                activeFence.points.splice(this.drawIndex, 1, point)
            } else {
                activeFence.points.push(point);
            }
            this.drawIndex ++;
        },
        drawFenceMove({point}) {
            if(!this.drawTurn || !this.isDrawing) {
                return;
            }

            // 获取当前活动的围栏
            const activeFence = this.fencePolygons.find(fence => fence.isActive);
            if (!activeFence) {
                return;
            }

            const len = activeFence.points.length;
            if( len === 0) {
                return;
            }
            if (len-1 === this.drawIndex) {
                activeFence.points.splice(this.drawIndex, 1, point)
            } else {
                activeFence.points.push(point);
            }
            this.$forceUpdate();
        },
        // 绘制结束
        drawFenceRightclick() {
            // 获取当前活动的围栏
            const activeFence = this.fencePolygons.find(fence => fence.isActive);

            if (activeFence && activeFence.points.length >= 3) {
                // 完成当前围栏的绘制
                activeFence.isActive = false;
                activeFence.path = activeFence.points.map(point => `${point.lng},${point.lat}`).join('|');

                // 重置绘制状态，准备绘制下一个围栏
                this.drawIndex = 0;
                // 保持绘制模式开启，允许绘制下一个围栏
                this.isDrawing = true;
                this.drawTurn = true;

                const completedCount = this.fencePolygons.filter(fence => !fence.isActive).length;
                this.$message.success(`围栏${completedCount}绘制完成，可以继续绘制下一个围栏`);
            } else {
                this.$message.warning('围栏至少需要3个点，请继续绘制');
                return;
            }

            // 强制刷新视图
            this.$forceUpdate();
        },
        // 回显电子围栏
        echoPolygonPath(fencePoint) {
            if (!fencePoint) {
                return;
            }

            // 如果传入的是字符串格式（来自其他文件的调用）
            if (typeof fencePoint === 'string') {
                const arr = fencePoint.split('|');
                const points = arr.map(item => {
                    const lngLat = item.split(',');
                    if (lngLat.length !== 2) return null;
                    const lng = parseFloat(lngLat[0]);
                    const lat = parseFloat(lngLat[1]);
                    if (isNaN(lng) || isNaN(lat)) return null;
                    return new this.BMap.Point(lng, lat);
                }).filter(point => point !== null);

                if (points.length > 0) {
                    this.fencePolygons = [{
                        points: points,
                        path: fencePoint,
                        timestamp: Date.now(),
                        isActive: false
                    }];
                }
            }
            // 如果传入的是数组格式（直接传入坐标点）
            else if (Array.isArray(fencePoint) && fencePoint.length > 0) {
                const validPoints = fencePoint.filter(point =>
                    point &&
                    typeof point.lng === 'number' &&
                    typeof point.lat === 'number' &&
                    !isNaN(point.lng) &&
                    !isNaN(point.lat)
                );

                if (validPoints.length > 0) {
                    this.fencePolygons = [{
                        points: validPoints,
                        path: validPoints.map(point => `${point.lng},${point.lat}`).join('|'),
                        timestamp: Date.now(),
                        isActive: false
                    }];
                }
            }
        },
        // 获取标记周边已关联项目
        getAssociatedProject(){
            this.$axios
                .get(`/interfaceApi/sale/engineering_manager/get_coordinate_by_num/${this.extr.projectnumber}`)
                .then(res => {
                    this.associatedProject = [];
                    if (res) {
                        this.$nextTick(()=>{
                            const url = require('./../images/mapIcon3.png');
                            const marker=  {
                                position: {lng: res.x_coordinate_point, lat: res.y_coordinate_point},
                                icon: {
                                    url: url,
                                    size: {
                                        width: 19,
                                        height: 31,
                                    }
                                },
                                offset: {
                                    width: 0,
                                    height: 31,
                                },
                                project_name: res.project_name,
                            }
                            this.associatedProject.push(marker);
                        })
                    }
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },

        // 获取标记周边项目
        getUnconnectedItems(coordinate){
            if(this.extr.type && this.extr.type === 1){
                const _that = this;
                var newCoordinate = `${coordinate.lng},${coordinate.lat}`;
                this.$axios
                    .post('/interfaceApi/sale/engineering_manager/get_project_coordinate',{
                        coordinate: newCoordinate,
                        distance: 10
                    })
                    .then(res => {
                        _that.unconnectedItems = [];
                        if (res && res.length > 0) {
                            const url = require('./../images/mapIcon2.png');
                            _that.$nextTick(()=>{
                                res.forEach(item => {
                                    const marker=  {
                                        position: {lng: item.x_coordinate_point, lat: item.y_coordinate_point},
                                        icon: {
                                            url: url,
                                            size: {
                                                width: 19,
                                                height: 31,
                                            }
                                        },
                                        offset: {
                                            width: 0,
                                            height: 31,
                                        },
                                        project_name: item.project_name,
                                    }
                                    _that.unconnectedItems.push(marker);
                                })
                            })
                        }
                    })
                    .catch(error => {
                        _that.$message.error(error.ErrorCode.Message);
                    });
            }
        },
        // 关联项目
        associatedProjects(data){
            this.$confirm(`确认关联【${data.project_name}】项目？`, '确认关联', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.selectAssociatedProjects = data.project_number;
                this.$message({
                    type: 'success',
                    message: '添加关联!'
                });
            });
        },
        // 获取默认地址
        async getDefaultPostion(){
            const pos = await this.$axios.get('/interfaceApi/BaseInfo/tenantposition/info');
            this.location.position = {lng: pos.longitude, lat: pos.latitude };
        },
    },

};
</script>
<style lang="stylus">
.amap-sug-result
    z-index 10000
.drawElectronicFence
    height 100%
    // padding .1rem
    overflow hidden
    .baidu-map
        height calc(100% - 80px)
        position relative
        .search-panel
            position: absolute;
            top: 57px;
            left: 10px;
            & > div > div:nth-child(1)
                height 500px
                overflow-y auto
        .BMapLabel
            border 0!important
            padding 2px 5px!important
            transform translateX(-40%)
    .map-con
        height 100%
        position relative
        .search-con
            position absolute
            top 10px
            left 10px
            height 45px
            display flex
            z-index: 10;
            box-shadow: 0 2px 2px rgba(0,0,0,.15);
            input
                width 315px
                background #ffffff
                border none
                padding 0 10px
            .search-btn
                width 45px
                background #1577d2
                color #fff
                border-radius 0 3px 3px 0
                text-align center
                line-height 45px
                cursor pointer
        .handle-btn
            padding-top 20px
            text-align center
            .el-button
                width 200px
        .handle-types
            position absolute
            bottom 10px
            right 0
            background #fff
            padding 10px
            .el-button
                height 36px
                padding 0 20px
            .active
                background #409EFF
                border-color #409EFF
                color #fff
</style>
